(function(){
  /* ============================================================
     1. Auto-filter "In stock" when a size filter is selected
     ============================================================ */
  function isSizeInput(input) {
    if (!input || input.type !== 'checkbox') return false;
    var name = (input.name || '').toLowerCase();
    if (name.indexOf('size') >= 0 || name.indexOf('option_size') >= 0 || name.indexOf('option-size') >= 0) return true;
    var label = input.closest('label');
    if (label) {
      var legend = label.closest('fieldset, details, .facets__disclosure, [class*="facet"]');
      if (legend) {
        var heading = legend.querySelector('summary, legend, .facets__summary, [class*="label"]');
        if (heading && /size/i.test(heading.textContent || '')) return true;
      }
    }
    return false;
  }

  function findInStockInput() {
    var inputs = document.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.checked) continue;
      var name = (input.name || '').toLowerCase();
      var label = input.closest('label');
      var labelText = label ? (label.textContent || '').toLowerCase() : '';
      var matchesAvailability = name.indexOf('availability') >= 0 || name.indexOf('in_stock') >= 0;
      var matchesLabel = /in[\s-]?stock|available/i.test(labelText);
      var isCorrectValue = input.value === '1' || input.value === 'true' || /in[\s-]?stock/i.test(input.value || '');
      if (matchesAvailability && (isCorrectValue || matchesLabel)) return input;
    }
    return null;
  }

  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.checked) return;
    if (!isSizeInput(e.target)) return;
    var stock = findInStockInput();
    if (stock) {
      stock.checked = true;
      stock.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ============================================================
     2. Sticky mobile add-to-bag bar (product pages only)
     ============================================================ */
  function initStickyBar() {
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'product') return;
    var bar = document.getElementById('ccb-sticky-bag');
    if (!bar) return;

    var addBtn = document.querySelector('add-to-cart-component button, button[name="add"], product-form-component button[type="submit"]');
    if (!addBtn) return;

    bar.classList.add('is-active');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.target === addBtn) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });
    observer.observe(addBtn);

    var stickyBtn = document.getElementById('ccb-sticky-bag-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var liveAddBtn = document.querySelector('add-to-cart-component button, button[name="add"], product-form-component button[type="submit"]');
        if (liveAddBtn) liveAddBtn.click();
      });
    }

    // Sync price when variant changes
    function syncPrice() {
      var priceEl = document.getElementById('ccb-sticky-bag-price');
      var livePrice = document.querySelector('.product-price__price, [class*="product-info"] [class*="price"], price-component .price');
      if (priceEl && livePrice && livePrice.textContent.trim()) {
        priceEl.textContent = livePrice.textContent.trim();
      }
    }
    var priceObserver = new MutationObserver(syncPrice);
    var liveTarget = document.querySelector('.product-price, [class*="product-info"]');
    if (liveTarget) priceObserver.observe(liveTarget, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
